import { ExtraResource } from "./CivUnique/ExtraResource"
import { ByzWaterLevel } from "./CivUnique/ByzWaterLevel"
import { CooldownAbility } from "./CivUnique/CooldownAbility"
import { LimitedCount } from "./CivUnique/LimitedCount"
import { UnlimitedCount } from "./CivUnique/UnlimitedCount"
import { getCombinedCount, getFrequencyCount } from "../../helpers/filterSquads"
import { GuildHall } from "./CivUnique/GuildHall"
import { GoldenAge } from "./CivUnique/GoldenAge"
import { JeanneXPBar } from "./CivUnique/JeanneXPBar"
import { VizierXPBar } from "./CivUnique/VizierXPBar"
import { ExtraResourceRelic } from "./CivUnique/ExtraResourceRelic"
import { AbilityActivated } from "./CivUnique/AbilityActivated"
import { LimitedTech } from "./CivUnique/LimitedTech"
import { MongolTrade } from "./CivUnique/MongolTrade"
import { DelhiScholar } from "./CivUnique/DelhiScholar"
import { MacedonianWarcamp } from "./CivUnique/MacedonianWarcamp"
import { HordeTribute } from "./CivUnique/HordeTribute"

function getJeanneIcon(data) {
    let icon = "/liveGameIcons/unique/jd/jeanne_villager.png";

    if (data?.jeanne_d_arc_melee_monarch_unlocked === true) return icon = "/liveGameIcons/unique/jd/jeanne_melee_monarch.png";
    if (data?.jeanne_d_arc_ranged_monarch_unlocked === true) return icon = "/liveGameIcons/unique/jd/jeanne_ranged_monarch.png";
    if (data?.jeanne_d_arc_melee_knight_unlocked === true) return icon = "/liveGameIcons/unique/jd/jeanne_melee_knight.png";
    if (data?.jeanne_d_arc_ranged_knight_unlocked === true) return icon = "/liveGameIcons/unique/jd/jeanne_ranged_knight.png";

    if (data?.jeanne_d_arc_archer_unlocked === true) return icon = "/liveGameIcons/unique/jd/jeanne_archer.png";
    if (data?.jeanne_d_arc_womanatarms_unlocked === true) return icon = "/liveGameIcons/unique/jd/jeanne_manatarms.png";

    return icon;
}

export function LiveGameCivUnique({ data, color }) {

    switch (data?.civilization) {
        case "Abbasid Dynasty":
            return (<>
                <GoldenAge goldenAgeLevel={data.statetree.data.golden_age} levels={[10, 30, 60]} />
            </>)

        case "Ayyubids":
            return (<>
                <GoldenAge goldenAgeLevel={data.statetree.data.golden_age} levels={[10, 20, 30, 50, 75]} />
            </>)

        case "Byzantines":
            
            return (<>
                <ExtraResource resourceCount={data.resources.oliveCurrent} resourcePerMin={data.resources.olivePerMin * 60} />
                {data.statetree.data.triumph_count !== -1 &&
                    <UnlimitedCount current={data.statetree.data.triumph_count} icon={'/liveGameIcons/unique/triumph.png'} />
                }
                <ByzWaterLevel waterLevel={data.statetree.data.cistern_water_level} />

                {Object.values(data.entities).some(e => e.pbg_id === 2104794 && e.building_progress === 1) &&
                    <UnlimitedCount current={data.statetree.data.flask_in_cistern_of_first_hill} icon={'/liveGameIcons/unique/pilgrim_flask.png'} />
                }
                {data.statetree.data.relic_in_grand_winery > 0 &&
                    <ExtraResourceRelic relicCount={data.statetree.data.relic_in_grand_winery} />
                }
            </>)

        case "Chinese":
            return (<>
                <LimitedCount current={getCombinedCount(data.squads, [181406])} max={4} icon={'/liveGameIcons/unique/imperial_official.png'} />
            </>)

        case "Zhu Xi's Legacy":
            let zhuxiLibraryTechs = ["2135959", "2127459", "2127520", "2127461", "2127464"]
            let unlockedLibrary = Object.values(data.technologies_researched).filter(tech => zhuxiLibraryTechs.includes(tech))

            let templeOfTheSunIcon = [
                '/liveGameIcons/unique/zhuxi/divine_haste.png',
                '/liveGameIcons/unique/zhuxi/divine_defense.png',
                '/liveGameIcons/unique/zhuxi/divine_charge.png',
                '/liveGameIcons/unique/zhuxi/divine_vitality.png'
            ]


            let maxIO = 4
            if (Object.values(data.technologies_researched).includes("2127326")) { maxIO += 2 } //Imperial Red Seals
            if (Object.values(data.technologies_researched).includes("2127520")) { maxIO += 2 } //Advanced Administration

            return (<>
                <LimitedCount current={getCombinedCount(data.squads, [2059966, 2631059])} max={maxIO} icon={'/liveGameIcons/unique/imperial_official.png'} />
                {Object.values(data.entities).some(e => e.pbg_id === 4927324) && //Zhuxi Library
                    <>
                        <LimitedTech pbg_id={unlockedLibrary[0] || null} />
                        <LimitedTech pbg_id={unlockedLibrary[1] || null} />
                    </>
                }
                {Object.values(data.entities).some(e => e.pbg_id === 7368723) && // Temple of the sun
                    <AbilityActivated icon={templeOfTheSunIcon[data.statetree.data.temple_of_the_sun_mode]} />
                }
            </>)

        case "English":
            return (<></>)

        case "French":
            return (<>
                {data.age >= 3 && Object.values(data.entities).some(e => e.pbg_id === 132779) &&
                    <GuildHall current={data.statetree.data.guild_hall_resource_count} resource={data.statetree.data.guild_hall_resource_type} />
                }
            </>)

        case "Jeanne d'Arc":
            let jeanneIcon = getJeanneIcon(data.statetree.data)

            return (<>
                <JeanneXPBar xp={data.statetree.data.jeanne_d_arc_total_experience} icon={jeanneIcon} color={color} />
                {data.age >= 3 && Object.values(data.entities).some(e => e.pbg_id === 8002900) &&
                    <GuildHall current={data.statetree.data.guild_hall_resource_count} resource={data.statetree.data.guild_hall_resource_type} />}
                {data.statetree.data.jeanne_d_arc_respawn_time >= 0 &&
                    <CooldownAbility icon={jeanneIcon} data={data.statetree.data.jeanne_d_arc_respawn_time} cooldownDuration={120} type="military" />
                }
            </>)

        case "Holy Roman Empire":
            return (<>
                <CooldownAbility icon={'/liveGameIcons/repair.png'} data={data.statetree.data.emergency_repair_cooldown} cooldownDuration={75} />
            </>)

        case "Order of The Dragon":
            return (<>
                <CooldownAbility icon={'/liveGameIcons/repair.png'} data={data.statetree.data.emergency_repair_cooldown} cooldownDuration={75} />
            </>)

        case "Japanese":
            return (<>
                <LimitedCount current={getCombinedCount(data.squads, [2127064, 2145966, 2145967, 2143512, 2143513, 2143514, 2127061, 2143515, 2143516])} max={data.statetree.data.bannerman_limit} icon={'/liveGameIcons/unique/samurai_mask.png'} />
                {data.age === 4 && Object.values(data.entities).some(e => e.pbg_id === 2122036) &&
                    <UnlimitedCount current={data.statetree.data.gunsmith_stockpile_count_jpn} icon={'/liveGameIcons/unique/unit_stat_supplies.png'} />
                }
            </>)

        case "House of Lancaster":
            let maxManor = Object.values(data.technologies_researched).includes("9000070") ? 10  //Open Field System
                : Object.values(data.technologies_researched).includes("5000160") ? 7 //Condeensed Land Practices
                    : 3
            return (<>
                <LimitedCount current={getFrequencyCount(Object.values(data.entities), [5000020])} max={maxManor} icon={'/liveGameIcons/unique/manor.png'} />
                {Object.values(data.entities).some(e => e.pbg_id === 5000026) && //Farimba Garrison
                    <LimitedCount current={getCombinedCount(data.squads, [5000070, 5000071])} max={4} icon={'/liveGameIcons/unique/lord_lancaster.png'} />
                }
            </>)

        case "Malians":
            let farimbaTechs = ["9000375", "9000508", "9000376", "9000509", "9000377", "9000510"] //Farimba Garrison Techs
            let unlockedFarimba = Object.values(data.technologies_researched).filter(tech => farimbaTechs.includes(tech))

            return (<>
                <LimitedCount current={getCombinedCount(data.squads, [2059966])} max={20} icon={'/liveGameIcons/unique/cattle.png'} />
                <LimitedCount current={getFrequencyCount(data.entities, [2067413, 2076058, 9002048])} max={data.age} icon={'/liveGameIcons/unique/building_pit_mine.png'} />
                {Object.values(data.entities).some(e => e.pbg_id === 2062447) && //Farimba Garrison
                    <>
                        <LimitedTech pbg_id={unlockedFarimba[0] || null} />
                        {data.age === 4 && <LimitedTech pbg_id={unlockedFarimba[1] || null} />}
                    </>
                }
                {Object.values(data.entities).some(e => e.pbg_id === 2062635) && //TODO Griot Bara
                    <>
                        <AbilityActivated />
                    </>
                }
            </>)

        case "Mongols":
            let traderCount = getCombinedCount(data.squads, [129600, 172771])
            let pastureCount = getFrequencyCount(data.entities, [168713, 169497])
            return (<>
                {traderCount >= 5 &&
                    <MongolTrade traderCount={traderCount} />
                }
                {pastureCount > 0 &&
                    <UnlimitedCount current={pastureCount} icon={'/liveGameIcons/unique/mongols/pasture.png'} />
                }
                {data.statetree.data.khan_respawn_time >= 0 &&
                    <CooldownAbility icon={'/liveGameIcons/unique/mongols/khan.png'} data={data.statetree.data.khan_respawn_time} cooldownDuration={120} type="military" />
                }
            </>)

        case "Ottomans":
            let maxMilitarySchools = data.age
            if (Object.values(data.technologies_researched).includes("2059331")) { maxMilitarySchools += 1 } //Military Campus
            return (<>
                <VizierXPBar xp={data?.statetree?.data?.imperial_council_exp_ott} xpRequired={data?.statetree?.data?.imperial_council_level_ott} color={color} />
                <LimitedCount current={getFrequencyCount(data.entities, [2058834])} max={maxMilitarySchools} icon={'/liveGameIcons/unique/military_school.png'} />
            </>)

        case "Rus":
            return (<>
                <UnlimitedCount current={parseInt(data.statetree.data.master_hunter_bounty_total_rus)} icon={'/liveGameIcons/unique/bounty.png'} />
                {data.age >= 2 &&
                    <UnlimitedCount current={parseInt(data.statetree.data.feudal_age_tickets)} icon={'/liveGameIcons/unique/unit_stat_supplies.png'} />
                }
            </>)

        case "Delhi Sultanate":
            return (<>
                <DelhiScholar scholarCount={data.statetree.data.scholar_in_research_building} />
            </>)

        case "Knights Templar":
            let fortressCount = getFrequencyCount(data.entities, [5000214])
            return (<>
                {fortressCount >= 1 &&
                    <UnlimitedCount current={fortressCount} icon={'/liveGameIcons/unique/fortress.png'} />}
            </>)

        case "Macedonian Dynasty":
            let warcamp_active = [
                '/liveGameIcons/unique/macedonian/atgeir.png',
                '/liveGameIcons/unique/macedonian/varangian.png',
                '/liveGameIcons/unique/macedonian/bogmadr.png',
                '/liveGameIcons/unique/macedonian/riddari.png',
                '/liveGameIcons/unique/macedonian/general_ship.png',
                '/liveGameIcons/unique/macedonian/war_galley.png'
            ]
            let hasCistern = getFrequencyCount(data.entities, [9000938])

            return (
            <>
                <ExtraResource resourceCount={data.resources.oliveCurrent} resourcePerMin={data.resources.olivePerMin * 60} icon="/liveGameIcons/silver.png" />
                <MacedonianWarcamp threshold={data.statetree.data.fallen_soldier_threshold} current={data.statetree.data.fallen_soldier} leftSide={true} activeAbility={warcamp_active[data.statetree.data.warcamp_active]} />

                {hasCistern !== 0 &&
                    <ByzWaterLevel waterLevel={data.statetree.data.cistern_charges} />}

                {data.statetree.data.relic_in_grand_winery > 0 &&
                    <ExtraResourceRelic relicCount={data.statetree.data.relic_in_grand_winery} icon={'/liveGameIcons/unique/silverRelics.png'} />
                }

            </>)

        case "Sengoku Daimyo":
            return (<>
                <LimitedCount current={getCombinedCount(data.squads, [9001316])} max={2 + data.age} icon={'/liveGameIcons/unique/yatai.png'} />
                {data.statetree.data.clan_hojo_level_jpn_ha_sen > 0 &&
                    <LimitedTech pbg_id={null} iconImage={`/liveGameIcons/unique/sengoku/${"hojo"}_daimyo_${data.statetree.data.clan_hojo_level_jpn_ha_sen}.png`} />
                }
                {data.statetree.data.clan_oda_level_jpn_ha_sen > 0 &&
                    <LimitedTech pbg_id={null} iconImage={`/liveGameIcons/unique/sengoku/${"oda"}_daimyo_${data.statetree.data.clan_oda_level_jpn_ha_sen}.png`} />
                }
                {data.statetree.data.clan_takeda_level_jpn_ha_sen > 0 &&
                    <LimitedTech pbg_id={null} iconImage={`/liveGameIcons/unique/sengoku/${"takeda"}_daimyo_${data.statetree.data.clan_takeda_level_jpn_ha_sen}.png`} />
                }
            </>)

        case "Tughlaq Dynasty":
            return (<>
                <LimitedCount current={getCombinedCount(data.squads, [9001124])} max={20} icon={'/liveGameIcons/unique/worker_elephant_count.png'} />
            </>)

        case "Golden Horde":
            let stockyardCount = getFrequencyCount(data.entities, [9001697])
            let ovooCount = getFrequencyCount(data.entities, [5650019, 7993333, 9001778, 9002133])

            let edict_active = [
                '/liveGameIcons/unique/horde/production_edict.png',
                '/liveGameIcons/unique/horde/defensive_edict.png',
                '/liveGameIcons/unique/horde/kharesh_edict.png',
                '/liveGameIcons/unique/horde/stockyard_edict.png'
            ]

            return (<>
                <AbilityActivated icon={edict_active[data.statetree.data.edict_active]} background={`/liveGameIcons/empty_background.png`} />
                {(data.age > 2 && data.statetree.data.rus_tributes_cost > 100) &&
                    <HordeTribute cost={data.statetree.data.rus_tributes_cost}/>
                }
                {stockyardCount > 0 &&
                    <UnlimitedCount current={stockyardCount} icon={'/liveGameIcons/unique/horde/stockyard.png'} />
                }

                {ovooCount > 1 &&
                    <UnlimitedCount current={ovooCount} icon={'/liveGameIcons/unique/ovoo.png'} />
                }

            </>)

        default:
            return (<>

            </>)

    }
}